<template>
  <input
    type="text"
    class="tg-date-picker--control"
    :class="{ active: isActive }"
  />
</template>

<script>
import $ from "jquery";

export default {
  name: "TgDatePicker",
  computed: {
    localeInfo() {
      if (["zh-cn", "zh-hk"].includes(this.$store.state.app.lang.key)) {
        return {
          format: "YYYY-MM-DD",
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          year: "年",
        };
      } else {
        return {
          format: "YYYY-MM-DD",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          fromLabel: "From",
          toLabel: "To",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          firstDay: 1,
          year: "",
        };
      }
    },
  },
  mounted: function () {
    let self = this;
    $(this.$el)
      .daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        locale: this.localeInfo,
        ...(this.options || {}),
      })
      .on("apply.daterangepicker", function (ev, picker) {
        self.$emit("input", picker.startDate.format("YYYY-MM-DD"));
      })
      .on("show.daterangepicker", () => {
        this.isActive = true;
      })
      .on("hide.daterangepicker", () => {
        this.isActive = false;
      });
    // 因為daterangepicker會有預設值，故同步給予vue component預設值
    self.$emit("input", $(this.$el).val());
  },
  beforeDestroy: function () {
    $(this.$el).daterangepicker("remove");
  },
  props: ["value", "options"],
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    input(value) {
      $(this.$el).val(value);
    },
    active(bool = true) {
      this.isActive = bool;
    },
  },
  watch: {
    value(value) {
      // 將props 的值傳遞給 jQuery's DOM
      $(this.$el).val(value);
    },
  },
};
</script>
